/**
 * Account API Service
 * Handles all account-related API calls (Chatwoot accounts per tenant)
 */
import { createApiInstance } from './api';

const accountApiInstance = createApiInstance('/accounts');

export const accountApi = {
  /**
   * List all accounts for a tenant
   * @param {string} tenantId - Tenant ID (required)
   * @returns {Promise} List of accounts
   */
  listAccounts: async (tenantId) => {
    const response = await accountApiInstance.get('/', {
      params: { tenant_id: tenantId }
    });
    return response.data;
  },

  /**
   * Get account by ID
   * @param {string} accountId - Account ID
   * @returns {Promise} Account details
   */
  getAccount: async (accountId) => {
    const response = await accountApiInstance.get(`/${accountId}`);
    return response.data;
  },

  /**
   * Create a new account
   * @param {Object} accountData - Account data
   * @returns {Promise} Created account
   */
  createAccount: async (accountData) => {
    const response = await accountApiInstance.post('/', accountData);
    return response.data;
  },

  /**
   * Update an existing account
   * @param {string} accountId - Account ID
   * @param {Object} updateData - Fields to update
   * @returns {Promise} Updated account
   */
  updateAccount: async (accountId, updateData) => {
    const response = await accountApiInstance.put(`/${accountId}`, updateData);
    return response.data;
  },

  /**
   * Deactivate an account
   * @param {string} accountId - Account ID
   * @returns {Promise} Success message
   */
  deactivateAccount: async (accountId) => {
    const response = await accountApiInstance.put(`/${accountId}`, { is_active: false });
    return response.data;
  },

  /**
   * Activate an account
   * @param {string} accountId - Account ID
   * @returns {Promise} Success message
   */
  activateAccount: async (accountId) => {
    const response = await accountApiInstance.put(`/${accountId}`, { is_active: true });
    return response.data;
  },
};

export default accountApi;
